/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, takeUntil} from 'rxjs/operators';

import sortBy from 'lodash-es/sortBy';

import {Destroyable} from '../../destroyable.component';
import {Report} from '../report';
import {OutputField} from '../reports.interfaces';
import {ReportsService} from '../reports.service';

@Component({
  selector: 'gp-report-result',
  templateUrl: './report-result.component.html',
  styleUrls: ['../report.scss', './report-result.component.scss']
})

export class ReportResultComponent extends Destroyable implements OnChanges, OnInit {

  @Input() public report: Report;
  @Input() public enabledFields: string[];
  public dragColumn: OutputField;
  private subject: Subject<any> = new Subject();

  constructor(private reportsService: ReportsService,
              private cd: ChangeDetectorRef) {
    super();
  }

  public ngOnInit(): void {
    this.subject
      .pipe(
        takeUntil(this.componentDestroyed$),
        distinctUntilChanged(),
        debounceTime(100),
        filter(() => !!this.dragColumn)
      )
      .subscribe((index: number) => {
        if (index !== this.dragColumn.fieldPosition) {
          this.reportsService.markAsChanged();
        }
        index += index > this.dragColumn.fieldPosition ? 0.5 : -0.5;
        this.dragColumn.fieldPosition = index;
        this.sortColumns();
        this.report.columns.forEach((element: OutputField, index: number) => {
          element.fieldPosition = index;
        });
        this.cd.markForCheck();
      });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.sortColumns();
  }

  public sortColumns(): void {
    this.report.columns.sort((a: OutputField, b: OutputField) => {
      return a.fieldPosition - b.fieldPosition;
    });
  }

  public onRemoveColumn(columnId: any): void {
    const index = this.report.columns.findIndex((column: OutputField) => column.field === columnId);
    if (index !== -1) {
      this.report.columns.splice(index, 1);
      this.reportsService.$reportUpdated.next(this.report);
      this.reportsService.markAsChanged();
    }
  }

  public onRecalculateOrders(): void {
    let ascColumns = this.report.columns.filter((column: OutputField) => column.fieldSortedBy);

    ascColumns = sortBy(ascColumns, 'fieldSortPosition');
    ascColumns.forEach((item, index) => {
      item.fieldSortPosition = index + 1;
    });
    this.reportsService.$reportUpdated.next(this.report);
    this.reportsService.markAsChanged();
  }

  public dragEnter(index: number): void {
    this.subject.next(index);
  }

  public dragStart(column: OutputField): void {
    this.dragColumn = column;
  }

  public dragEnd(): void {
    this.dragColumn = null;
  }
}
